import React, { useState, useCallback, useRef, useEffect } from 'react';
import {useHistory} from 'react-router-dom';
import { inject } from 'mobx-react';
import {toast} from 'react-toastify';
import { UserGrid } from './user-grid';
import userStore from '../../../shared/stores/user-store';

const ManageUsers = ({userStore}) => {
    const history = useHistory();
    const onSelectionChange = useCallback((selected) => {
        //Navigate to the form for that user
        history.push(`/users/view/${selected}`)
    }, [])
    const [userItems, setUserItems] = useState(userStore.users);

    return (
        <UserGrid dataSource={userItems} onRowClick={(rowdata) => {onSelectionChange(rowdata._id)}}/>
    )
}

const injectWithStores = inject('userStore');

export default injectWithStores(({userStore}) => { 
    return (
        <div>
            <div className="grid-x padding-top-1 padding-left-1">
                <div className="cell auto">
                    <h3 data-ta="mngUsersHeader">Manage Users</h3>
                </div>
            </div>
            <ManageUsers userStore={userStore} />
        </div>
    )
})

